import { Locale } from 'modules/i18n';

export const statisticsTabsTranslation = {
  [Locale.en]: {
    statistics: 'Overview',
    rawData: 'Requests',
  },
};
